export const TextLabelScadaIcon = () => (
  <svg width="54" height="17" viewBox="0 0 54 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.5" y="0.5" width="53" height="16" rx="1.5" stroke="#8C969B" />
    <rect x="7" y="6" width="40" height="5" fill="#CFD3D5" />
  </svg>
);
